import React, { useState, useRef, useEffect } from 'react'
import { message, } from 'antd'
import classNames from 'classnames'
import qs from 'qs'
import { Ul, Li } from 'meinian-package/src/baseComponent'
import Icon from 'meinian-package/src/component/icon'
import Modal from 'meinian-package/src/component/modal'
import Dropdown from 'meinian-package/src/baseComponent/dropdown'
import Input from 'meinian-package/src/baseComponent/input'
import request from 'meinian-package/src/utils/request'
import { useNavigate } from 'react-router-dom'
import { BatchItem } from '../batch'
import './index.less'

export default (props) => {
  const { tag, init, isBatch } = props
  const $icon = useRef()

  const onDeleteTag = async (_tag, e) => {
    e && e.stopPropagation()
    Modal.show({
      title: '提示',
      children: `确定要删除'${_tag.tagName}'吗？删除标签后不能恢复`,
      onOk: async () => {
        try {
          await request.post('/zhikuan/img-tag/delete-tag', { tagId: _tag.tagId })
          init()
          message.success('已删除')
        } catch (err) {
          message.error(err)
        }
      },
    })
  }
  const onDeleteImgInTag = async (_tag, e) => {
    e && e.stopPropagation()
    Modal.show({
      title: '提示',
      children: `确定要删除包含'${_tag.tagName}'的图片吗？删除图片后不能恢复`,
      onOk: async () => {
        try {
          await request.post('/zhikuan/img-tag/delete-tag-img', { tagId: _tag.tagId })
          init()
          message.success('已清空')
        } catch (err) {
          message.error(err)
        }
      },
    })
  }
  const history = useNavigate()
  return <div>{isBatch ? <BatchItem keyValue={tag.tagId} hiddenCheckbox className={classNames('meinian-tag', 'batch')}>
    <span className="name line-1" title={tag.tagName}>{tag.tagName}</span>
    <span className="count">{tag.imgCount}</span>
  </BatchItem>
    : <div className="meinian-tag" onClick={() => history(`/home/tag/detail?${qs.stringify({ tagId: tag.tagId, tagName: tag.tagName })}`)}>
      <span className="name line-1" title={tag.tagName}>{tag.tagName}</span>
      <span className="count">{tag.imgCount}</span>
      <Dropdown
        trigger="click"
        placement="bottomCenter"
        overlay={<Ul style={{ padding: '4px 0' }} onClick={e => e && e.stopPropagation()}>
          <Li className="action-item" onClick={e => onDeleteTag(tag, e)}>删除标签</Li>
          <Li className="action-item" onClick={e => onDeleteImgInTag(tag, e)}>删除标签所有图片</Li>
          <div onClick={e => e && e.stopPropagation()}><RenameTag tag={tag} onChange={() => init && init()}> <Li className="action-item">重命名标签</Li></RenameTag></div>
        </Ul>}
        getPopupContainer={() => $icon.current}
      >
        <span className="icon" onClick={e => e && e.stopPropagation()} ref={$icon}>
          <Icon type="m-bianji" />
        </span>
      </Dropdown>
    </div>}
  </div>
}

export const CreateTag = (props) => {
  const { onChange, className } = props
  const [visible, setVisible] = useState(false)
  const [name, setName] = useState('')

  const onClick = () => {
    setVisible(true)
    props.onClick && props.onClick()
  }
  return <>
    <span className={className} onClick={onClick}>
      {props.children || '新增标签'}
    </span>
    {visible ? <Modal
      title="新增标签"
      visible={visible}
      onVisibleChange={_visible => setVisible(_visible)}
      okText="新增"
      closeAfterOk={false}
      onOk={async () => {
        if (!name.trim()) {
          return
        }
        try {
          await request.post('/zhikuan/img-tag/save-tag', { tagName: name })
          message.success(`已新增标签“${name}”`)
          setVisible(false)
        } catch (error) {
          console.error(error)
          if (error.errorCode === 'IMG_TAG001') {
            message.error(`标签“${name}”已存在`)
          }
        }
        onChange && onChange()
      }}
    >
      <>
        <div style={{ marginBottom: 10 }}>请在下方输入新的标签名称：</div>
        <Input placeholder="标签名称" onChange={e => setName(e.target.value)} />
      </>
    </Modal> : null}
  </>
}

export const RenameTag = (props) => {
  const { onChange, className, tag } = props
  const [visible, setVisible] = useState(false)
  const [name, setName] = useState(tag.tagName)

  useEffect(() => {
    setName(tag.tagName)
  }, [visible])

  const onClick = (e) => {
    setVisible(true)
    props.onClick && props.onClick(e)
  }
  return <>
    <span className={classNames(className)} onClick={onClick}>
      {props.children || '重命名标签'}
    </span>
    {visible ? <Modal
      title="重命名标签"
      visible={visible}
      onVisibleChange={_visible => setVisible(_visible)}
      onOk={async () => {
        try {
          await request.post('/zhikuan/img-tag/rename-tag', { tagId: tag.tagId, tagName: name })
          onChange && onChange()
          message.success('重命名成功')
        } catch (error) {
          console.error(error)
          if (error.errorCode === 'IMG_TAG001') {
            Modal.show({
              title: '提示',
              children: `标签名称“${name}”已存在，是否将“${tag.tagName}”合并至“${name}”?`,
              onOk: async () => {
                try {
                  await request.post('/zhikuan/img-tag/merge-tags', { tagIds: [error.result, tag.tagId], tagName: name })
                } catch (err) {
                  console.error(err)
                }
                onChange && onChange()
              }
            })
          }
        }
      }}
    ><>
      <div style={{ marginBottom: 10 }}>请在下方输入新的标签名称：</div>
      <Input placeholder="请输入新的标签名称" value={name} onChange={e => setName(e.target.value)} />
    </>
    </Modal> : null}
  </>
}
